import { render } from "./product-detail-size.vue?vue&type=template&id=863e8356&lang=pug"
import script from "./product-detail-size.vue?vue&type=script&lang=js"
export * from "./product-detail-size.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__